import {HTTP} from '@/CallAPI'
export default {
  getListStatus () {
    return HTTP.get('status', {params: {
      status: 'all'
    }})
  }
}



// WEBPACK FOOTER //
// ./src/service/status.js